@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- #FORM BODY -->
      <div class="row mt-3">
        <div class="col-12 d-flex flex-column">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'control-panel.vehicles.vehicleType' | translate}}
                </label>
          <p-select
              [options]='vehicleTypeList' [(ngModel)]='entity.type'
              placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.types.type' | translate }}"
              dataKey='id' optionLabel='name'
              [style]="{'width':'100%'}"
              appendTo='body'
              (onChange)="typeChanged($event)"
              filter="true" filterBy="name">
            </p-select>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 d-flex flex-column">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'control-panel.vehicles.vehicleBrand.name' | translate}}
                </label>
          <p-select
              [options]='brandList' [(ngModel)]='entity.brand'
              placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.brands.brand' | translate }}"
              dataKey='id' optionLabel='name'
              [style]="{'width':'100%'}"
              appendTo='body'
              filter="true" filterBy="name">
            </p-select>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 d-flex flex-column">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.name' | translate}}
                </label>
          <input type="text" id="vehicle-data-settings-name" class="form-control custom-input"
              style="width:100%;"
              [(ngModel)]="entity.name">
        </div>
      </div>
      <!-- ROW 4 -->
      @if (!isNew) {
        <div class="row mt-3">
          <div class="col-12">
            <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
              {{'general.enabled' | translate}}
            </label>
            <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
                type="checkbox" [(ngModel)]="modelEnabled" style="margin-right:10px;" />
          </div>
        </div>
      }
    </div>
  </div>
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" [disabled]="!canUpdate" i18n>
                {{'general.save' | translate}}
              </button>
            </div>
          }
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n>
                {{'general.create' | translate}}
              </button>
            </div>
          }
        </div>
        @if (!isNew) {
          <div class="p-2 bd-highlight">
            <div>
              <button class="btn custom-button" (click)="changeStatus(modelEnabled)" [disabled]="!canDisable" i18n>
                {{'general.changeStatus' | translate}}
              </button>
            </div>
          </div>
        }
      </div>
    </ng-template>
</p-dialog>
}